import * as React from 'react';
const SvgClose = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='m10 10.774-3.56 3.561a.5.5 0 0 1-.374.167.56.56 0 0 1-.38-.187.54.54 0 0 1-.181-.387q0-.207.18-.388L9.227 10 5.665 6.44a.5.5 0 0 1-.167-.384.57.57 0 0 1 .188-.39q.18-.182.387-.182.205 0 .387.181L10 9.226l3.56-3.56a.55.55 0 0 1 .384-.178q.21-.003.39.177.183.181.182.388 0 .205-.181.387L10.774 10l3.56 3.561q.174.174.178.373.005.2-.177.38a.54.54 0 0 1-.387.182.54.54 0 0 1-.387-.181z'
            />
        </g>
    </svg>
);
export default SvgClose;
